import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { BUSINESS, NAV_LINKS } from "../data";
import { scrollToId } from "../hooks/useSmoothScroll";

export const Footer = () => (
  <footer className="bg-forest-700 border-t border-white/10 pt-16 pb-8 px-5 md:px-10" data-testid="footer">
    <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-10 md:gap-8">
      <div className="md:col-span-2">
        <Logo />
        <p className="text-sand/60 mt-5 max-w-sm leading-relaxed">{BUSINESS.tagline}</p>
        <p className="text-sand/40 text-sm mt-4">
          We connect serious land buyers with vacant lots that fit their exact criteria and give sellers a fast, no-hassle cash offer.
        </p>
      </div>

      <div>
        <h4 className="text-sand text-xs uppercase tracking-[0.25em] mb-5">Quick Links</h4>
        <ul className="space-y-3">
          {NAV_LINKS.map((l) => (
            <li key={l.id}>
              <button
                data-testid={`footer-link-${l.id}`}
                onClick={() => scrollToId(l.id)}
                className="text-sand/60 hover:text-terracotta transition-colors duration-300 text-sm"
              >
                {l.label}
              </button>
            </li>
          ))}
          <li>
            <Link data-testid="footer-privacy" to="/privacy" className="text-sand/60 hover:text-terracotta transition-colors duration-300 text-sm">
              Privacy Policy
            </Link>
          </li>
        </ul>
      </div>

      <div>
        <h4 className="text-sand text-xs uppercase tracking-[0.25em] mb-5">Get In Touch</h4>
        <ul className="space-y-4 text-sm">
          <li>
            <a href={BUSINESS.phoneHref} className="flex items-center gap-3 text-sand/70 hover:text-terracotta transition-colors duration-300">
              <Phone size={16} className="text-terracotta" /> {BUSINESS.phone}
            </a>
          </li>
          <li>
            <a href={`mailto:${BUSINESS.email}`} className="flex items-start gap-3 text-sand/70 hover:text-terracotta transition-colors duration-300 break-all">
              <Mail size={16} className="text-terracotta shrink-0 mt-0.5" /> {BUSINESS.email}
            </a>
          </li>
          <li className="flex items-center gap-3 text-sand/70">
            <MapPin size={16} className="text-terracotta" /> {BUSINESS.area}
          </li>
        </ul>
      </div>
    </div>

    <div className="max-w-7xl mx-auto mt-14 pt-6 border-t border-white/10 flex flex-col gap-4">
      <p className="text-sand/50 text-xs leading-relaxed max-w-3xl" data-testid="footer-coverage">
        Currently buying vacant land in 46 states nationwide. Not yet active in Illinois, Oklahoma, South Carolina, or Virginia.
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-2 border-t border-white/5">
        <p className="text-sand/40 text-sm">© 2025 {BUSINESS.legal}</p>
        <Link to="/privacy" className="text-sand/40 text-sm hover:text-terracotta transition-colors duration-300">Privacy Policy</Link>
      </div>
    </div>
  </footer>
);
